module.exports = __webpack_public_path__ + "media/components/Alert/exclamation-74bf1e43bf9ad87ec5550b64fe9616b3.svg";